import { Search } from './../../modules/shares/component/tree-graph/econode';
import { Injectable } from '@angular/core'
import { BaseService } from '@appService/base.service'
import { Observable } from 'rxjs'
import { ResponseModel } from '../api-response.model'

@Injectable({
  providedIn: 'root'
})
export class OrganizationService extends BaseService {
  contextPath = '/api/v1/admin/organization'
  contextPathLocal = '/api/organizations' // tự tạo org từ hệ thống của mình

  //  lấy phòng ban theo điều kiện
  postDepartmentList(param: any, body: any): Observable<ResponseModel<any>> {
    return this.post(`${this.contextPath}/get-list`, body, param)
  }

  getOrgs(param: any): Observable<ResponseModel<any[]>> {
    return this.post(`${this.contextPath}/search-all`, param)
  }

  getOrgsDropdown(param: any): Observable<ResponseModel<any[]>> {
    return this.post(`${this.contextPath}/get-orgs-dropdown`, param)
  }

  getOrgsByUser(param: any): Observable<ResponseModel<any[]>> {
    return this.post(`${this.contextPath}/get-orgs-by-user`, param)
  }

  getUsersDropdown(param: any): Observable<ResponseModel<any[]>> {
    return this.post(`${this.contextPath}/get-users-dropdown`, param)
  }

  getUsersByOrg(param: any): Observable<ResponseModel<any[]>> {
    return this.post(`${this.contextPath}/get-users-by-org`, param)
  }

  getOrgsByAcc(param: any, userId: any): Observable<ResponseModel<any[]>> {
    return this.post(`${this.contextPath}/get-org-by-acc?userId=` + userId, param)
  }


  create(param: any): Observable<ResponseModel<any>> {
    return this.post(`${this.contextPath}/create`, param)
  }

  update(param: any): Observable<ResponseModel<any>> {
    return this.post(`${this.contextPath}/update`, param)
  }

  view(param: any): Observable<ResponseModel<any>> {
    return this.post(`${this.contextPath}/detail`, param)
  }

  changeStatus(payload: any): Observable<ResponseModel<any[]>> {
    return this.post(`${this.contextPath}/update-status`, payload)
  }

  getUsersByOrgId(param: any): Observable<ResponseModel<any[]>> {
    return this.post(`${this.contextPath}/search-users`, param)
  }

  removeUser(param: any): Observable<ResponseModel<any>> {
    return this.post(`${this.contextPath}/remove-user`, param)
  }

  addUser(param: any): Observable<ResponseModel<any>> {
    return this.post(`${this.contextPath}/add-user`, param)
  }

  updateUserRole(param: any): Observable<ResponseModel<any>> {
    return this.post(`${this.contextPath}/update-user-role`, param)
  }

  // phòng ban chủ động được tạo từ bên mình
  createOrg(params: any): Observable<any> {
    return this.post(`${this.contextPathLocal}`, params)
  }

  updateOrg(params: any): Observable<any> {
    return this.put(`${this.contextPathLocal}/${params?.id}`, params)
  }

  deleteOrg(params: any): Observable<any> {
    return this.delete(`${this.contextPathLocal}/${params?.id}`)
  }

  getOrgDetail(params: any): Observable<any> {
    return this.get(`${this.contextPathLocal}/${params?.id}`)
  }

  getOrgList(params: any): Observable<any> {
    return this.get(`${this.contextPathLocal}/list`, params)
  }

  search(params: any): Observable<any> {
    return this.get(`${this.contextPathLocal}`, params)
  }

}
